import { openBlock as t, createElementBlock as l, createStaticVNode as a } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, c = /* @__PURE__ */ a('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#0052B4" d="M29.703 2.509A19.908 19.908 0 0 0 20 0C8.955 0 .001 8.953 0 19.998l13.913-6.955L29.703 2.51ZM0 20.002C.001 31.047 8.955 40 20 40c3.521 0 6.83-.911 9.703-2.509l-15.79-10.535L0 20.002Z"></path><path fill="#D80027" d="M31.37 3.545a20.014 20.014 0 0 0-1.667-1.036L0 19.998v.004l29.703 17.49c.573-.32 1.13-.666 1.667-1.037L3.424 20 31.369 3.545Z"></path><path fill="#A2001D" d="M34.783 19.254H32.4c.62-.744.581-1.85-.116-2.548a1.893 1.893 0 0 0 0-2.677l-.045.045c.74-.74.784-1.982.045-2.722L21.576 22.06c.74.74 1.917.73 2.656-.009l.206-.188 5.127-.466v2.205h1.74v-2.363L33.912 21l.87-1.747Z"></path><path fill="#FFDA44" d="m21.74 24.348-1.74-.87 1.74-.87h11.304v1.74H21.74Z"></path>', 5), o = [
  c
];
function h(n, i) {
  return t(), l("svg", e, [...o]);
}
const r = { render: h };
export {
  r as default,
  h as render
};
